import { Injectable } from '@angular/core';
import { APP } from './../constants';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AlmacenesService {
	apiUrl = APP.ApiEndpoint;

	constructor(
		private _http: HttpClient) { }

	public listarAlmacenes(data: any, callback) {
		const url = `${this.apiUrl}/api/almacenes/`;
		const self = this;
		return this._http.post(url, data).subscribe((result) => {
			callback(result);
		});
	}
}
